export const foodData = {
    "all foods": [
      {
        name: "Manchurian",
        Rating: "4/5"
      },
      {
        name: "Pani Puri  ",
        Rating: " 5/5"
      },
      {
        name: "Bhelpuri",
        Rating: "4.5/5"
      },
      {
        name: "Alu chaat",
        Rating: " 4.9/5"
      },
      {
        name: "Alu Paratha",
        Rating: " 4.8/5"
      },
      {
        name: "Makka ki roti",
        Rating: " 4/5"
      },
      {
        name: "Chole bhature",
        Rating: " 4.7/5"
      },
      {
        name: "Lassi",
        Rating: " 4/5"
      },
      {
        name: "Dal Bati Churma",
        Rating: " 4.2/5"
      },
      {
        name: "Ker Sangri",
        Rating: " 4/5"
      },
      {
        name: "Papad Ki  Sabzi",
        Rating: " 3/5"
      },
      {
        name: "Onion Kachori",
        Rating: "3.5/5"
      }
    ],
    "Street  foods": [
      {
        name: "Manchurian",
        Rating: " 4/5"
      },
      {
        name: "Pani Puri  ",
        Rating: " 5/5"
      },
      {
        name: "Bhelpuri",
        Rating: " 4.5/5"
      },
      {
        name: "Alu chaat",
        Rating: " 4.9/5"
      }
    ],
    "Punjabi foods": [
      {
        name: "Alu Paratha",
        Rating: " 4.8/5"
      },
      {
        name: "Makka ki roti",
        Rating: " 4/5"
      },
      {
        name: "Chole bhature",
        Rating: " 4.7/5"
      },
      {
        name: "Lassi",
        Rating: " 4/5"
      }
    ],
    "Rajisthan foods": [
      {
        name: "Dal Bati Churma",
        Rating: " 4.2/5"
      },
      {
        name: "Ker Sangri",
        Rating: " 4/5"
      },
      {
        name: "Papad Ki  Sabzi",
        Rating: " 3/5"
      },
      {
        name: "Onion Kachori",
        Rating: "3.5/5"
      }
    ]
  };
  